export default __webpack_public_path__ + "static/media/booking-icon.8d69338c.svg";